module.exports = __webpack_public_path__ + "img/forecast_eng.bc9cf10c.png";